import React, { useState } from 'react'
import { staticFiles } from '../../components/Helpers/Static'
import { trimString } from '../../components/Helpers/Common'

function ShareToCard({ item, add, remove, isUser, isSelected }) {

    function handleChange() {
        if (isSelected) {
            remove(item.id)
        } else {
            add(item.id)
        }
    }

    let style = (isSelected ? 'bg-blue' : '')
    style += ' appearance-none rounded-full w-full h-full'

    // const CheckBox = () => {
    //     let style = (check ? 'bg-blue' : '')
    //     style += ' appearance-none rounded-full w-full h-full'
    //     return (
    //         <div className='border-2 border-black rounded-full w-8 h-8 p-1'>
    //             <input type='checkbox' className={style} onChange={handleChange} />
    //         </div>
    //     )
    // }

    return (

        <div className='flex justify-between w-full'>
            <div className='flex items-center gap-3'>
                <img
                    src={isUser ?
                        item.photo ?
                            item.photo : staticFiles.noProfilePic
                        :
                        staticFiles.noProfilePic
                    }
                    className='rounded-full w-10 h-10'
                    alt={isUser ? item.fullname : item.name}
                />
                <div className='font-regular text-sm truncate mr-5'>
                    {trimString(isUser ? item.fullname : item.name, 55)}
                </div>
            </div>
            <div className='flex items-center checkGreen'>
                <label class="container-check">
                    <input type="checkbox" checked={isSelected} onChange={handleChange} />
                    <span class="checkmark"></span>
                </label>
                {/* <input type='checkbox' className='w-6 h-6 cursor-pointer' onChange={handleChange} checked={isSelected} /> */}
            </div>
        </div>
    )
}

export default ShareToCard
